/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Installment } from './installment';


export interface Payment { 
    id?: number;
    totalAmount?: number;
    numberOfInstallments?: number;
    method?: Payment.MethodEnum;
    status?: Payment.StatusEnum;
    createdAt?: string;
    updatedAt?: string;
    accessPlanId?: number;
    planCpfcnpj?: string;
    installments?: Array<Installment>;
}
export namespace Payment {
    export type MethodEnum = 'CREDIT_CARD' | 'PIX' | 'BOLETO' | 'BANK_TRANSFER';
    export const MethodEnum = {
        CreditCard: 'CREDIT_CARD' as MethodEnum,
        Pix: 'PIX' as MethodEnum,
        Boleto: 'BOLETO' as MethodEnum,
        BankTransfer: 'BANK_TRANSFER' as MethodEnum
    };
    export type StatusEnum = 'PENDING_PAYMENT' | 'PARTIALLY_PAID' | 'PAID' | 'FAILED' | 'CANCELLED';
    export const StatusEnum = {
        PendingPayment: 'PENDING_PAYMENT' as StatusEnum,
        PartiallyPaid: 'PARTIALLY_PAID' as StatusEnum,
        Paid: 'PAID' as StatusEnum,
        Failed: 'FAILED' as StatusEnum,
        Cancelled: 'CANCELLED' as StatusEnum
    };
}


